export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const APP_VERSION = process.env.REACT_APP_VERSION || "dev";

export const AUTH_LOCALSTORAGE = "token";
export const DO_LOGIN = "/auth/login";
export const REQUEST_TOKEN_FORGOT_PASSWORD = "/auth/request-token-forgot-password";
export const NEW_PASSWORD_FORGOT_PASSWORD = "/auth/new-password-forgot-password";
export const REMOVE_USER_ROLE = "/users/roles"
export const USERS = "/users";
export const  PASSWORD_POLICIES_CHANGE_POLICY ="/passwordPolicies/change-policy";
export const  GET_PASSWORD_POLICY ="/passwordPolicies/password-policy";
export const USERS_BY_NUIT = "/users/nuit";
export const USERS_BY_BI = "/users/bi";
export const USERS_GET_USERNAME_SUGGESTION = "/users/username/suggestion";
export const ROLES = "/roles";
export const ROLES_ADD_CLAIMS = "/roles/add/claims";
export const ROLES_ADD_CLAIM = "/roles/add/claim";
export const ROLES_REMOVE_CLAIMS = "/roles/remove/claims";
export const ROLES_REMOVE_CLAIM = "/roles/remove/claim";
export const ROLES_RESET_CLAIMS = "/roles/reset/claims";
export const ROLES_GET_CLAIMS = "/roles/get/claims";
export const CLAIMS = "/claims";
export const GET_USER_CLAIMS = "users/claims";
export const GET_USER_ROLES = "users/roles";
export const AUTH_CHANGE_PASSWORD = "/auth/change-password";
export const AUTH_LOCK = "/auth/lock";
export const AUTH_RESET_PASSWORD = "/auth/reset-password";
export const FACULTIES = "/faculties";
export const FACULTIES_BY_IDS_DEPARTAMENTS = "/faculties/idsDepartments";
export const DEPARTAMENTS = "/departments";
export const DEPARTAMENTS_BY_IDS_COURSES = "/departments/idsCourses";
export const COURSES = "/courses";
export const COURSES_SUBJECTS = "/coursesSubjects";
export const COURSE_PLAN = "/coursePlan";
export const PLAN_SUBJECT = "/planSubject";
export const SCIENTIFICAREAS = "/scientificareas";
export const ACADEMICYEARS = "/academicyears";
export const STUDENT_SUBJECTS_GRADE = "/studentsubjectgrade";
export const GENERATE_PRINT_DOCUMENT = "/templatesControllers";
export const CURRENT_ACADEMICYEAR = "/academicyears/current";
export const DISABLE_ACADEMICYEAR = "/academicyears/disable/";
export const ACADEMIC_PERIODS = "/academicperiods";
export const SUBJECTS = "/subjects";
export const SUBJECTS_PLAN = "/subjectplans";
export const SUBJECTS_REPROVED = "/subjects/student/subjects-reproved";
export const SUBJECTS_APPROVED = "/subjects/student/subjects-approved";
export const STUDENTS = "/students";
export const STUDENTS_SUBSCRIPTIONS_SUBJECTS = "students/subscriptions/subjects";
export const STUDENTS_UNSYNCED = "students/unsynced";
export const Key_student_subscriptions_subjects = "key_students_subscriptions_subjects";
export const STUDENT_CLASSES = "/studentclasses";
export const DUPLICATED_SCHOOL_CODES = "/students/duplicatedschoolcodes";
export const STUDENTS_SYNC = "/students/sync";
export const ENROLLMENTS = "/enrollments";
export const ENROLLMENTS_BY_STUDENT = "/enrollments/student";
export const ENROLLMENTS_DOCUMENTS = "/enrollmentdocuments";
export const SUBSCRIPTIONS = "/subscriptions";
export const SUBSCRIPTIONS_SUBJECTS_IN_CLASS = "/subscriptionSubjects/subscriptionSubjectsInClass";
export const SUBSCRIPTIONS_BY_STUDENT = "/subscriptions/byStudent";
export const SUBSCRIPTION_STATISTICS = "/subscriptions/statistics";
export const SUBSCRIPTION_STATISTICS_BY_COURSE  = "/subscriptions/statistics/courses";

export const SUBSCRIPTIONS_SUBJECTS = "/subscriptionsubjects";
export const STUDENTS_CREATE_CODE = "/students/studentcode";

export const ENROLLMENT_REQUIRED_DOCUMENTS = "/enrollmentrequireddocuments";
export const RULES_DOCUMENT_TEACHER = "/rulesteacherdocuments";
export const TEACHERS = "/teachers";
export const GET_TEACHER_BY_USER_ID = "/teachers/userid";
export const TEACHER_CREATE_CODE = "/teachers/teachercode";
export const TEACHERS_DOCUMENTS = "/teacherDocuments";
export const TEACHERS_SYNC = "/teachers/sync";
export const TEACHERS_DEPARTAMENTS = "/teachersDepartaments";
export const CLASSES = "/classes";
export const TEACHERS_CLASSES_SUBJECTS = "/classsubjectteachers";
export const ASSESSMENTS = "/assessments";
export const ASSESSMENTS_STUDENT = "/assessments/student";
export const TEACHERS_CLASSES = "/teachers/classes";
export const TEACHERS_SUBJECTS = "/teachers/subjects";
export const STUDENT_ASSESSMENTS = "/studentassessments";
export const STUDENT_ASSESSMENTS_BLOCK_OR_UNBLOCK = "/studentassessments/blockOrUnblock";
export const CLASSROOMTYPES = "/classroomtypes";
export const CLASSROOM = "/classrooms";
export const VACANCIES = "/vacancies";
export const SCHOOLS_SCHEDULES = "/schoolschedules";
export const SCHOOLS_SCHEDULES_STUDENT = "/schoolschedules/student";
export const TEACHER_EVALUATION_CRITERIAS = "/teacherevaluationcriterias";
export const TEACHER_EVALUATIONS = "/teacherevaluations";
export const TEACHER_EVALUATIONS_CRITERIAS = "/teacherevaluationscriterias";
export const TEACHER_EVALUATIONS_CRITERIAS_REPORT = "/teacherevaluationscriterias/report";

export const STUDENT_DOCUMENTS = "/studentdocuments";
export const LESSON_PLANS = "/lessonplans";
export const LESSON_PLANS_DOCUMENTS = "/lessonplandocuments";
export const MANAGERS = "/managers";
export const CTAS = "/ctas";
export const LATE_FEE_CONFIGS = "/latefeeconfigies";
export const SCHOOL_BANK_CONFIGS = "/schoolbankconfigs";
export const PAYMENT_TYPES = "/paymenttypies";
export const STUDENT_DEBTIES = "/studentdebties";
export const IRREGULAR_STUDENT_DEBTIES = `${STUDENT_DEBTIES}/irregular`
export const GENERATE_STUDENT_DEBTIES_REFERENCES = "/studentdebties/references";
export const GET_MONTHSPAYMENTS = "/studentdebties/monthsPayments";
export const STUDENT_DEBTIES_BY_SUBSCRIPTIONS = "/studentdebties/subscriptions";
export const STUDENT_DEBTIES_BY_ENROLLMENTS = "/studentdebties/enrollments";
export const PAYMENT_TRANSACTIONS = "/paymenttransactions";
export const PAYMENT_REFERENCES = "/paymentreferences";
export const UPLOAD_PAYMENT_REFERENCES_FILE = "/PaymentReferences/upload/payment-file";
export const GENERATOR_REFERENCE_CODE = "/paymentreferences/generate/reference";
export const STUDENT_DEBTS_NOTIFICATIONS = "/studentDebtNotifications";
export const STUDENT_DEBTS_TOTAL_BY_STUDENT_ID = "/studentdebties/totals/student";
export const PAYMENT_METHODS = "/paymentmethods";

export const REPORTS_GET_ACTIVE_DEBTS = "/reports/getactivedebts";
export const REPORTS_GET_DEBTS_BY_PERIOD = "/reports/getdebtsbyperiod";
export const REPORTS_GET_OVERDUE_DEBTS = "/reports/getoverduedebts";
export const REPORTS_GET_DEBT_DISTRIBUTION_BY_PAYMENT_TYPE = "/reports/getdebtdistributionbypaymenttype";
export const REPORTS_GET_PAYMENTS_HISTORY_BY_STUDENT = "/reports/getpaymentshistorybystudent";
export const REPORTS_GET_TOTAL_PAYMENTS_BY_PERIODS = "/reports/gettotalpaymentsbyperiods";
export const REPORTS_GET_COMPLIANCE_RATE = "/reports/getcompliancerate";
export const REPORTS_GET_TOTALS_LATES_FEES = "/reports/gettotalslatesfees";
export const REPORTS_GET_STUDENTS_WITH_MOST_DELAYS = "/reports/getstudentswithmostdelays";
export const REPORTS_GET_PAYMENT_REPORT = "/reports/GetPaymentReport";
export const REPORTS_GET_PAYMENT_REFERENCE_STATUS = "/reports/GetPaymentReferenceStatus";
export const REPORTS_PAYMENT_REFERENCE = "/PaymentReferences/paymentReport";



export const ENTITIES = "/entities";
export const SUBENTITIES = "/subentities";
export const GET_SUBENTITIES_BY_ID_ENTITY = "/subEntities/GetSubEntitiesByIdEntity";
export const EXHIBITORS = "/exhibitors";
export const EXHIBITORS_JUDGES_BY_USER_ID = "/exhibitors";
export const EXHIBITORS_PROJECTS = "/exhibitorsprojects";
export const ENTITIES_PROJECTS = "/entitiesproject";
export const SUBENTITIES_PROJECTS = "/subentitiesproject";
export const JUDGES = "/judges";
export const JUDGE_PHASE_PROJECTS = "/judgesPhasesProjects";
export const GET_PROJECT_IN_JUDGE_PHASE_PROJECTS_BY_ID_JUDGE = "/judgesPhasesProjects/GetProjectsAssignedByIdJudge";
export const JUDGE_PHASE_PROJECT_DOCUMENTS = "/judgesphasesprojectsdocuments";
export const JUDGE_PHASE_PROJECT_DOCUMENTS_BY_PROJECT = "/judgesphasesprojectsdocuments/projects";
export const PHASES = "/phases";
export const PROJECTS = "/projects";
export const PROJECT_EXPENSES = "/projectExpenses";
export const PROJECT_TYPES = "/projectTypes";
export const PROJECTS_DOCUMENTS = "/projectDocuments";


export const CATEGORY  = "/categories";
export const AUTHOR = "/authors";
export const BOOK = "/books";
export const BOOK_AUTHOR = "/bookAuthors";
export const LOAN = "/loans";
export const RESERVATION = "/reservations";
export const LIBRARY_STATS = "/libraryStats";
export const STUDENT_CERTIFICATE_DOWNLOAD = "/StudentCertificates/download";
export const STUDENT_CERTIFICATES = "/StudentCertificates";
export const NAVIGATION_LOGS = "/NavigationLogs";


export const COURSE_PAYMENTS = "/coursePayments";
export const PROCESS_MODELS = "/processModels";
export const Key_coursePayments = "coursePayments-pagination";
export const Key_processModels = "processModels-pagination";

export const Key_universities = 'universities-pagination';
export const UNIVERSITIES = "/universities";
export const UNIVERSITIES_BY_IDS_UNIVERSITIES = "/universities/faculties";


export const KNOWLEDGE_DOMAINS  = "/KnowledgeDomains";
export const key_KnowledgeDomains = "KnowledgeDomains-pagination";

export const Key_knowledgeSubDomains = 'knowledgeSubDomains-pagination';
export const KNOWLEDGE_SUBDOMAINS = "/knowledgeSubDomains";
// export const KNOWLEDGE_SUBDOMAINS_BY_DOMAIN = "/knowledgeSubDomains/byDomain";

export const SCHOLARSHIP_TYPES = "/scholarshipTypes";
export const key_ScholarshipTypes = "ScholarshipTypes-pagination";

export const SCHOLARSHIPS = "/scholarships";
export const key_Scholarships = "Scholarships-pagination";


export const Key_AcademicLevels = 'academicLevels-pagination';
export const ACADEMIC_LEVELS = "/academicLevels";
export const ESURA_API_CONNECTION_PROPERTIES = "/EsuraApiConnectionProperties"
export const Key_FormationAreas = "formationAreas-pagination";
export const FORMATION_AREAS = "/formationAreas";
export const EmailSettings = "/EmailSettings"
export const Key_StudentSituations = "studentSituations-pagination";
export const STUDENT_SITUATIONS = "/studentSituations";


export const ENROLLMENTS_STUDENTS_STATS = "/enrollments/statistics/students";
export const Key_enrollments_students_stats = "enrollments-statistics-students";

export const SCHOLARSHIP_PROVIDERS = "/scholarshipProviders";
export const key_ScholarshipProviders = "ScholarshipProviders-pagination";

export const UPLOAD_IMAGES ="/UploadImages"
export const key_reservations = "reservations-pagination";
export const key_libraryStats = "libraryStats-pagination";
export const key_loans = "loans-pagination";
export const key_categories  = "categories-pagination";
export const key_authors = "authors-pagination";
export const key_books = "books-pagination";
export const key_bookAuthors = "bookAuthors-pagination";
export const Theme_Preferences = "/ThemePreferences";
export const Models = "/Models";
export const Manuals = "/Manuals";


export const UserManagement = "Gestão de utilizadores";
export const PAGE_SIZE = 100;
export const PAGE_NUMBER = 1;

export const ERR_NETWORK = 'ERR_NETWORK';
export const UNABLE_TO_REACH_SERVER = 'Unable to reach the server. Please check your connection or try again later.';
export const NO_RESPONSE_RECEIVED = 'No response received from the server. Please try again later.';
export const UNKNOWN_ERROR = 'An unknown error occurred.';

export const LANGUAGES = [
  { label: "English", code: "en" },
  { label: "Portuguese", code: "pt" }
];

//hook query gets keys 
export const Key_academicPeriod = 'academicPeriod-pagination'
export const Key_subscriptionStatistics = 'Key_subscriptionStatistics'
export const Key_subscriptionStatisticsByCourse = 'Key_subscriptionStatisticsByCourse'
export const Key_academicYear = 'academicYears-pagination'
export const Key_claims = 'claims'
export const Key_courses = 'courses-pagination'
export const Key_currentAcademicYear = 'current-academic-year'
export const Key_departaments = 'departaments-pagination'
export const Key_enrollmentRequiredDocuments = 'enrollmentRequiredDocuments-pagination'
export const Key_teacherRequiredDocuments = 'teacherRequiredDocuments-pagination'
export const Key_faculties = 'faculties-pagination'
export const Key_roleClaims = 'roleClaims'
export const Key_roles = 'roles-pagination'
export const Key_scientificAreas = 'scientificAreas-pagination'
export const Key_subjects = 'subjects-pagination'
export const Key_userClaims = 'userClaims'
export const Key_userRoles = 'userRoles'
export const Key_users = 'users-pagination'
export const Key_enrollments = 'enrollments-pagination'
export const Key_enrollmentDocuments = 'enrollmentDocuments-pagination'
export const Key_teachers= 'teachers-pagination'
export const Key_classes= 'classes-pagination'
export const key_assignedTeacherClassesSubjects= 'assignedTeacherClassesSubjects-pagination'
export const key_assessments= 'assessments-pagination'
export const key_assessments_student= 'assessments_student-pagination'
export const key_studentsClasses= 'studentsClasses-pagination'
export const Key_subscriptions= 'subscriptions-pagination'
export const Key_subscriptionSubjectsInClass= 'subscriptionSubjectsInClass-pagination'
export const Key_classroomtypes= 'classroomtypes-pagination'
export const Key_classroom= 'classrooms-pagination'
export const Key_studentsUnsynced= 'Key_studentsUnsynced-pagination'
export const Key_studentsWithDuplicatedCodes= 'Key_studentsWithDuplicatedCodes-pagination'
export const Key_vacancies= 'vacancies-pagination'
export const Key_schoolschedules= 'schoolschedules-pagination'
export const Key_teacherEvaluationCriterias= 'teacherEvaluationCriterias-pagination'
export const Key_teacherevaluations= 'teacherevaluations-pagination'
export const Key_teacherevaluationsreport= 'teacherevaluationsreport-pagination'
export const Key_studentDocuments= 'studentDocuments-pagination'
export const Key_subjectplans= 'subjectplans-pagination'
export const Key_lessonPlanDocuments= 'lessonPlanDocuments-pagination'
export const Key_lessonPlans= 'lessonPlans-pagination'
export const Key_managers= 'managers-pagination'
export const Key_ctas= 'ctas-pagination'
export const Key_lateFeeConfigs= 'lateFeeConfigs-pagination'
export const Key_paymenttypies= 'paymenttypies-pagination'
export const Key_paymentMethods= 'paymentMethods-pagination'
export const Key_studentdebties= 'studentdebties-pagination'
export const Key_studentTotals= 'studentTotals-pagination'
export const Key_paymenttransactions= 'paymenttransactions-pagination'
export const Key_paymentreferences= 'paymentreferences-pagination'
export const Key_studentDebtNotifications= 'studentDebtNotifications-pagination'
export const key_userId= 'userId'
export const key_userBi= 'userBI'
export const key_userNuit= 'userNuit'
export const key_studentData= 'userNuit'
export const key_EsuraApiConnectionProperties = 'EsuraApiConnectionProperties'
export const key_EmailSetings = 'EmailSettings'
export const Key_entities = "entities-pagination";
export const Key_subEntities = "subEntities-pagination";
export const Key_exhibitors = "exhibitors-pagination";
export const Key_exhibitorsProjects = "exhibitorsProjects-pagination";
export const Key_judges = "judges-pagination";
export const Key_judgePhaseProjects = "judgePhaseProjects-pagination";
export const Key_judgePhaseProjectDocuments = "judgePhaseProjectDocuments-pagination";
export const Key_judgePhaseProjectDocumentsByIdProject = "judgePhaseProjectDocumentsByIdProject-pagination";
export const Key_phases = "phases-pagination";
export const Key_projects = "projects-pagination";
export const Key_projectExpenses = "projectExpenses-pagination";
export const Key_projectTypes = "projectTypes-pagination";
export const Key_projectsDocuments = "projectsDocuments-pagination";
export const  APPROVED = "Aprovado";
export const  REPROVED = "Reprovado";
export const  MINIMUM_GRADE = 9.5;

export const SEARCH_BY_ENTER = true;
export const SEARCH_BY_BUTTON = true;

export const processModelName_preSubscription = 'processo_de_inscricao';
export const processModelName_renewEnrollmentByStudent = 'processo_de_renovacao_de_matricula_pelo_estudante';